

/// <reference path="StockNote.ts" />

// Generated class WarehouseOrder_ManagedObject

class WarehouseOrder_ManagedObject extends StockNote
{
}
